import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertTriangle, FileText, Calendar, Printer } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="py-24 px-6 bg-darknavy relative" data-id="element-90">
      <div className="max-w-3xl mx-auto space-y-20" data-id="element-91">
        {/* Objection Handling */}
        <div className="space-y-6 border-l-2 border-amber/20 pl-6 md:pl-10" data-id="element-92">
          <h3 className="text-2xl font-heading text-cream" data-id="element-93">
            "¿Y si mi ansiedad es fuerte?"
          </h3>
          <p className="text-lg text-cream-dim" data-id="element-94">
            Entonces más razón para tener un guión.
          </p>
          <p className="text-lg text-cream-dim" data-id="element-95">
            A las 3AM no necesitas pensar bonito. <br data-id="element-96" />
            Necesitas un movimiento corto que le diga al cuerpo:{' '}
            <span className="text-amber" data-id="element-97">"no hay emergencia".</span>
          </p>
        </div>

        {/* Deliverables */}
        <div id="precio" className="bg-midnight p-8 md:p-12 rounded-2xl border border-amber/20 shadow-2xl relative overflow-hidden" data-id="element-98">
          <div className="absolute top-0 right-0 w-32 h-32 bg-amber/10 rounded-bl-full -mr-10 -mt-10" data-id="element-99" />

          <h3 className="text-3xl font-heading text-cream mb-8 text-center" data-id="element-100">
            Lo que recibes hoy
          </h3>

          <ul className="space-y-4 mb-12" data-id="element-101">
            <DeliverableItem icon={<FileText data-id="element-103" />} text="PDF completo Reset 3AM" data-id="element-102" />
            <DeliverableItem icon={<Printer data-id="element-105" />} text="Tarjetas imprimibles para la mesita de noche" data-id="element-104" />
            <DeliverableItem icon={<FileText data-id="element-107" />} text="Plantillas: Descarga PM + Descarga 3AM" data-id="element-106" />
            <DeliverableItem icon={<Calendar data-id="element-109" />} text="Tracker de 14 noches" data-id="element-108" />
          </ul>

          <div className="text-center space-y-6 pt-6 border-t border-white/10" data-id="element-110">
            <div className="space-y-2" data-id="element-111">
              <span className="text-warmgray text-sm uppercase tracking-widest" data-id="element-112">
                Precio Único
              </span>
              <div className="flex items-center justify-center gap-4" data-id="element-113">
                <span className="text-2xl font-heading text-warmgray/50 line-through" data-id="element-114">
                  US$17
                </span>
                <span className="text-5xl font-heading text-amber font-bold" data-id="element-115">
                  US$6.39
                </span>
              </div>
              <span className="inline-block bg-amber/15 text-amber text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full border border-amber/20" data-id="element-116">
                62% de descuento
              </span>
            </div>

            <CTAButton fullWidth className="max-w-md mx-auto" href="https://rutinasimple.com/cart/51971920527641:1" data-id="element-117">
              Descargar Reset 3AM Ahora
            </CTAButton>

            <p className="text-xs text-warmgray mt-4" data-id="element-118">
              Acceso inmediato • Pago seguro • Formato Digital
            </p>
          </div>
        </div>

        {/* For Whom */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-119">
          <div data-id="element-120">
            <h4 className="text-xl font-heading text-cream mb-6 flex items-center gap-2" data-id="element-121">
              <CheckCircle2 className="text-amber w-5 h-5" data-id="element-122" />
              Es para ti si:
            </h4>
            <ul className="space-y-3 text-cream-dim" data-id="element-123">
              <li className="flex items-start gap-3" data-id="element-124">
                <span className="w-1.5 h-1.5 rounded-full bg-amber mt-2 shrink-0" data-id="element-125" />
                te despiertas 3–5am y tu mente arranca
              </li>
              <li className="flex items-start gap-3" data-id="element-126">
                <span className="w-1.5 h-1.5 rounded-full bg-amber mt-2 shrink-0" data-id="element-127" />
                te da pánico mirar la hora
              </li>
              <li className="flex items-start gap-3" data-id="element-128">
                <span className="w-1.5 h-1.5 rounded-full bg-amber mt-2 shrink-0" data-id="element-129" />
                quieres algo privado, rápido y práctico
              </li>
            </ul>
          </div>

          <div data-id="element-130">
            <h4 className="text-xl font-heading text-warmgray mb-6 flex items-center gap-2" data-id="element-131">
              <AlertTriangle className="text-warmgray w-5 h-5" data-id="element-132" />
              No es para ti si:
            </h4>
            <ul className="space-y-3 text-warmgray/80" data-id="element-133">
              <li className="flex items-start gap-3" data-id="element-134">
                <span className="w-1.5 h-1.5 rounded-full bg-warmgray/50 mt-2 shrink-0" data-id="element-135" />
                necesitas diagnóstico médico inmediato
              </li>
              <li className="flex items-start gap-3" data-id="element-136">
                <span className="w-1.5 h-1.5 rounded-full bg-warmgray/50 mt-2 shrink-0" data-id="element-137" />
                sospechas apnea u otro problema respiratorio
              </li>
              <li className="flex items-start gap-3" data-id="element-138">
                <span className="w-1.5 h-1.5 rounded-full bg-warmgray/50 mt-2 shrink-0" data-id="element-139" />
                estás en crisis emocional severa (ahí se prioriza ayuda
                profesional)
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
function DeliverableItem({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <li className="flex items-center gap-4 text-cream-dim p-3 bg-white/5 rounded-lg" data-id="element-140">
      <div className="text-amber shrink-0" data-id="element-141">{icon}</div>
      <span data-id="element-142">{text}</span>
    </li>;
}